import { Component, OnInit, Input } from '@angular/core';
import { Investor } from '../../shared/models/investor';
import { ScorecardCalcService } from '../../../services/scorecard-calc.service';

@Component({
  selector: 'app-score-card',
  templateUrl: './score-card.component.html',
  styleUrls: ['./score-card.component.css']
})
export class ScoreCardComponent implements OnInit {
  @Input()
  investor: Investor;
  @Input() flags: any;

  score: number;
  scoreCard: string;

  constructor(private scoreCalc: ScorecardCalcService) { }

  ngOnInit() {
    this.score = this.scoreCalc.getScore(this.investor);
    console.log(this.score);
   // this.scoreCard = this.scoreCalc.getScoreCard(this.score);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/hwcheckup/score-card/score-card.component.ts